import React, {Dispatch, SetStateAction} from 'react';
import {chakra, Checkbox, Text, TextProps} from '@chakra-ui/react';

type Props = TextProps & {
  linkTargetId: string,
  isAgreedWith: boolean,
  setIsAgreedWith: Dispatch<SetStateAction<boolean>>
};

export default function Agreement({
  linkTargetId,
  isAgreedWith,
  setIsAgreedWith,
  ...props
}: Props) {
  return (
      <Text fontSize={['sm', 'sm', 'md']} color="gray.500" {...props}>
        <Checkbox isChecked={isAgreedWith} onChange={(event) => setIsAgreedWith(prev => !prev)}>
          <AgreementLink href="/terms" target="terms" label="利用規約" />・<AgreementLink href="https://corkagency.com/privacy" target="privacy" label="プライバシーポリシー" /> に同意して
        </Checkbox>
        <chakra.span className={`btn-large btn-down btn-blue ${isAgreedWith ? '' : 'btn-disabled'}`} display="block" mt={[3, 3, `${18/16}rem`]}>
          <a href={`#${linkTargetId}`}>体験スタート</a>
        </chakra.span>
      </Text>
  );
}

function AgreementLink({href, target, label}: {href: string, target: string, label: string}) {
  return (
    <chakra.a href={href} target={target} display="inline" textDecoration="underline">{label}</chakra.a>
  );
}
